import { Col, List, Row } from 'antd';
import SectionTitle from 'components/Section/SectionTitle';
import Link from 'next/link';
import { styled } from 'styled-components';

const ListStyled = styled(List)`
    .ant-list-item {
        padding: 0px 16px;
    }
    .ant-list-header {
        padding-top: 12px;
        padding-bottom: 6px;
    }
`;

const BranchTitle = styled.h5`
    font-size: 18px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.56;
    letter-spacing: normal;
    text-align: left;
    padding: 0;
    margin: 0;
    a {
        color: ${({ theme }) => theme.colors.greyishBrown};
    }
`;

const BranchName = styled.h6`
    font-size: 18px;
    font-weight: 300;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.56;
    letter-spacing: normal;
    text-align: left;
    margin: 0;
    a {
        color: ${({ theme }) => theme.colors.greyishBrown};
    }
`;

interface GroupedByParentBranch {
    [key: string]: {
        title: string;
        seoSlug: string;
        items: [
            {
                title: string;
                seoSlug: string;
            }
        ];
    };
}

const groupByParentBranch = (branches: Branch[]): GroupedByParentBranch => {
    return branches.reduce((r, a) => {
        if (a.lvl === 1) {
            r[a.seoSlug] = {
                title: a.title,
                seoSlug: a.seoSlug,
                items: []
            };
        } else {
            r[a.parent.seoSlug] = {
                title: a.parent.title,
                seoSlug: a.parent.seoSlug,
                items: [
                    ...(r[a.parent.seoSlug] || { items: [] }).items,
                    { title: a.title, seoSlug: a.seoSlug }
                ]
            };
        }
        return r;
    }, {});
};

type Props = {
    branches: Branch[];
};

export const BranchSection = ({ branches }: Props) => {
    const groupedBranches = Object.values(groupByParentBranch(branches));
    return (
        <Row>
            <Col span={24}>
                <SectionTitle title="Branże" />
            </Col>
            {groupedBranches.map((branch) => {
                if (branch.items.length > 0) {
                    return (
                        <Col span={24} key={branch.seoSlug}>
                            <ListStyled
                                split={false}
                                rowKey={({ seoSlug }: Branch): string => seoSlug}
                                size="small"
                                header={
                                    <BranchTitle>
                                        <Link href={`/katalog-firm?branch=${branch.seoSlug}`}>
                                            {branch.title}
                                        </Link>
                                    </BranchTitle>
                                }
                                dataSource={branch.items}
                                renderItem={(item: Branch) => (
                                    <List.Item>
                                        <BranchName>
                                            <Link href={`/katalog-firm?branch=${item.seoSlug}`}>
                                                {item.title}
                                            </Link>
                                        </BranchName>
                                    </List.Item>
                                )}
                            />
                        </Col>
                    );
                }
                return (
                    <Col span={24} key={branch.seoSlug}>
                        <BranchTitle>
                            <Link href={`/katalog-firm?branch=${branch.seoSlug}`}>
                                {branch.title}
                            </Link>
                        </BranchTitle>
                    </Col>
                );
            })}
        </Row>
    );
};

export default BranchSection;
